import { Injectable } from '@angular/core';
import { CommonService } from "./common.service";
import { ApiService } from "./api.service";
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { InventoryAccuracyParam } from '../models/InventoryAccuracyParam';
import { DateRangeParam } from '../models/DateRangeParam';
import { DefectivePartsPerMillionParam } from '../models/DefectivePartsPerMillionParam';
import { TransitionalInventoryParam } from '../models/TransitionalInventoryParam';
import { OnTimeShipmentParam } from '../models/OnTimeShipmentParam';
import { WidgetDetailParam } from '../models/WidgetDetailParam';
import { HospitalPackedParam,OrderFillRateParam,ZoneBalancingParam, Level2WidgetDetailParam } from '../models/index';
import { ToteRecirculatingPyramid, ForcePackwaves, MHENoReadData, BlindCountError, WidgetParam } from '../models/DataModels';

@Injectable()
export class AnalyticsService {

  constructor(
    private _apiService: ApiService,
    private _commonService: CommonService
  ) { }

  getMHCurrentInventory(facilityId, customerId) {
    return this._apiService
      .get('', 'api/analytics/getmhcurrentinventory/' + facilityId + '/' + customerId)
  }

  getInventoryAccuracy(criteria: InventoryAccuracyParam) {
    return this._apiService
      .post('', 'api/analytics/getinventoryaccuracy', criteria)
  }

  getDates(criteria: DateRangeParam) {
    return this._apiService
      .post('', 'api/analytics/getdates', criteria)
  }

  gethospitalordersummary(facilityId, customerId) {
    return this._apiService
      .get('', 'api/analytics/gethospitalordersummary/' + facilityId + '/' + customerId)
  }
  getDefectivePartsPerMillion(criteria: DefectivePartsPerMillionParam) {
    return this._apiService
      .post('', 'api/analytics/getdefectivepartspermillion', criteria)
  }
  
  getTransitionalInventory(criteria: TransitionalInventoryParam) {
    return this._apiService
      .post('', 'api/analytics/gettransitionalinventory', criteria)
  }
  getOnTimeShipment(criteria: OnTimeShipmentParam) {
    return this._apiService
      .post('', 'api/analytics/getontimeshipment', criteria)
  }
  
  getWidgetDetail(DetailAPIPath: string, widgetParam: WidgetDetailParam) {
    return this._apiService
    .post('', DetailAPIPath, widgetParam)
  }

    
  getWidgetLevel2Detail(Level2DetailAPIPath: string, widgetParam: Level2WidgetDetailParam) {
    return this._apiService
    .post('', Level2DetailAPIPath, widgetParam)
  }

  getHospitalPackedSummary(criteria: HospitalPackedParam) {
    return this._apiService
    .post('', 'api/analytics/GetHospitalPackedSummary', criteria)
  }

  getOrderFillRateSummary(criteria: OrderFillRateParam) {
    return this._apiService
    .post('', 'api/analytics/GetOrderFillRateSummary', criteria)
  }

  getZoneBalancingSummary(criteria: ZoneBalancingParam) {
    return this._apiService
    .post('', 'api/analytics/GetZoneBalancingSummary', criteria)
  }

  getOrderSummary(criteria: WidgetDetailParam) {
    return this._apiService
    .post('', 'api/analytics/GetOrderSummary', criteria)
  }

  GetForcePackwavesSummary(criteria: WidgetParam) : Observable<Array<ForcePackwaves>> {
    return this._apiService
    .post('', 'api/analytics/GetForcePackwavesSummary', criteria)
  }

  GetToteRecirculatingSummary(criteria: WidgetParam) : Observable<Array<ToteRecirculatingPyramid>> {
    return this._apiService
    .post('', 'api/analytics/GetToteRecirculatingPyramidSummary', criteria)
  }

  GetMHENoReadDataSummary(criteria: WidgetParam) : Observable<Array<MHENoReadData>> {
    return this._apiService
    .post('', 'api/analytics/GetMHENoReadDataSummary', criteria)
  }

  GetBlindCountErrorSummary(criteria: WidgetParam) : Observable<Array<BlindCountError>> {
    return this._apiService
    .post('', 'api/analytics/GetBlindCountErrorSummary', criteria)
  }

  GetHospitalPackedOrderSummary(criteria: WidgetParam) {
    return this._apiService
    .post('', 'api/analytics/GetHospitalPackedOrderSummary', criteria)
  }

  GetMHEMonitoringSummary(criteria: WidgetParam) {
    return this._apiService
    .post('', 'api/analytics/GetMHEMonitoringSummary', criteria)
  }
}



// WEBPACK FOOTER //
// ./src/app/services/analytics.service.ts